import { ReactComponent as GreenStarSVG } from "../../assets/icons/greenStar.svg";
import { ReactComponent as GreenStarsSVG } from "../../assets/img/reviewStars.svg";

interface PromoReviewBlockProps {
    img: string;
    imgMobile?: string;
    title: string;
    date: string;
    text: string;
}
const PromoReviewBlock = ({ img, imgMobile, title, date, text }: PromoReviewBlockProps) => {
    return (
        <div className="grid gap-6 text-white female:text-black">
            <img src={img} alt="" className="hidden rounded-2xl" />
            <img src={imgMobile} alt="" className="rounded-2xl" />
            <div className="grid gap-4">
                <div className="flex items-end gap-2">
                    <GreenStarsSVG className="h-[20px]" />
                    <GreenStarSVG className="h-[20px]" />
                    <span className="text-zing-16-22 font-semibold">Trustpilot</span>
                </div>
                <div className="grid gap-2">
                    <div className="grid grid-flow-col items-center justify-between text-zing-18-26">
                        <div className="font-semibold">{title}</div>
                        <div className="female:zing-neutral-cool-grey-600 text-zing-gray-200">
                            {date}
                        </div>
                    </div>
                    <div className="text-zing-16-22">{text}</div>
                </div>
            </div>
        </div>
    );
};

export default PromoReviewBlock;
